import React, { useCallback } from 'react';

import { Box, Typography } from '@mui/material';
import LazyWrapper from 'app/shared/components/common/LazyWrapper';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { ConfirmIcon } from '../../icons';

import { optionStyles } from './AutocompleteCDS.styles';

const AutocompleteCDSOption = ({
  option,
  optionLabel,
  optionProps,
  OptionContent,
  optionClassName,
  name,
  dataTestId,
  isLazyWrapped,
  isSelected,
  selectedRef,
  multiple,
}) => {
  const renderedOption = OptionContent ? (
    <OptionContent multiple={multiple} option={option} optionText={optionLabel} />
  ) : (
    <Typography data-truncated className="truncate" variant="regular16">
      {optionLabel}
    </Typography>
  );

  const setSelectedRef = useCallback(
    ref => {
      if (!isSelected || selectedRef.current) {
        return;
      }

      selectedRef.current = ref;
    },
    [isSelected, selectedRef],
  );

  return (
    <Box
      {...optionProps}
      aria-selected={isSelected}
      className={clsx(
        optionClassName,
        'px-2 py-5 autocomplete-option-wrapper',
        optionProps.className,
      )}
      data-fieldname={name}
      data-testid={dataTestId}
      ref={setSelectedRef}
      sx={optionStyles}
    >
      <LazyWrapper isTurnedOff={!isLazyWrapped} offset={300}>
        {renderedOption}
        {multiple && isSelected && <ConfirmIcon size={IconSize[16]} />}
      </LazyWrapper>
    </Box>
  );
};

AutocompleteCDSOption.propTypes = {
  dataTestId: PropTypes.string.isRequired,
  isLazyWrapped: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  multiple: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  option: PropTypes.object.isRequired,
  optionClassName: PropTypes.string.isRequired,
  optionLabel: PropTypes.string.isRequired,
  selectedRef: PropTypes.object.isRequired,
  OptionContent: PropTypes.elementType,
  optionProps: PropTypes.object,
};

export default AutocompleteCDSOption;
